import { EFinancingProgram } from '@if/core/types'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { useDeleteCoapplicant } from '@src/data/api/credit-api/credit-api'
import { useTranslation } from 'react-i18next'

interface Props {
  id: string
  financingProgramId: EFinancingProgram
}
const DeleteCoApplicantButton = ({ id, financingProgramId }: Props) => {
  const { t } = useTranslation()
  const [deleteCoapplicant, isDeleting] = useDeleteCoapplicant()

  return (
    <AsyncActionButton
      sx={{ mb: 1 }}
      fullWidth
      variant="contained"
      isPending={isDeleting}
      onClick={async () => {
        await deleteCoapplicant({ creditApplicationId: id, financingProgramId })
      }}
    >
      {t('viewCreditApplication.deleteCoapplicant')}
    </AsyncActionButton>
  )
}

export default DeleteCoApplicantButton
